import React from "react";

export default function TabsNav({ tabsConfig, activeIndex = 0 }) {
  return (
    <div className="nav nav-tabs" id="nav-tab" role="tablist">
      {tabsConfig.map((tab, idx) => (
        <button
          className={`nav-link ${idx === activeIndex ? "active" : ""}`}
          id={`nav-${tab.name}-tab`}
          data-bs-toggle="tab"
          data-bs-target={`#nav-${tab.name}`}
          type="button"
          role="tab"
          aria-controls={`nav-${tab.name}`}
          aria-selected="true"
          onClick={tab.clickHandler}
          key={tab.name}
        >
          {tab.mobileLabel ? (
            <>
              <span className="nav-link__label nav-link__label--full">
                {tab.label}
              </span>
              <span className="nav-link__label nav-link__label--short">
                {tab.mobileLabel}
              </span>
            </>
          ) : (
            tab.label
          )}
        </button>
      ))}
    </div>
  );
}
